module.exports = __webpack_public_path__ + "img/35.90527caf.jpg";